module.exports = __webpack_public_path__ + "static/media/icon_window-swap.4d4210a7.svg";